// @flow

/**
 * Masks a phone number to show only the last 4 digits
 */
export const maskPhoneNumber = (phoneNumber: string): string => {
  if (!phoneNumber) return ''

  // Remove non-digit characters
  const digitsOnly = phoneNumber.replace(/\D/g, '')
  return digitsOnly.slice(-4)
}

export const extractContactFromResponse = (response: any): string => {
  return response?.data?.data?.to_contact || response?.data?.data?.toContact || ''
}
